import { FC } from "react";
import { PenaltyKick } from "../../types/fixtures/match";
import { SectionTitle } from "./SectionTitle";

interface PenaltySeriesProps {
    homePenalties: PenaltyKick[];
    awayPenalties: PenaltyKick[];
}

export const PenaltySeries: FC<PenaltySeriesProps> = ({
    homePenalties,
    awayPenalties,
}) => {
    if (!homePenalties.length && !awayPenalties.length) {
        return null;
    }

    return (
        <div>
            <SectionTitle>
                Серия пенальти
            </SectionTitle>
            <div className="flex flex-row mx-auto w-full gap-3 justify-center items-start">
                <div className="flex flex-col gap-4 w-1/2 sm:w-80 justify-start items-end">
                    {homePenalties.map((penalty, index) => (
                        <div key={index} className="flex flex-row">
                            <a href={penalty.player.url}>
                                {penalty.player.name}
                            </a>
                            <span className="px-1">
                                {!penalty.missed ? ' ✅ ' : ' ❌ '}
                            </span>
                        </div>
                    ))}
                </div>
                <div className="flex flex-col gap-4 w-1/2 sm:w-80 justify-start items-start">
                    {awayPenalties.map((penalty, index) => (
                        <div key={index} className="flex flex-row-reverse">
                            <a href={penalty.player.url}>
                                {penalty.player.name}
                            </a>
                            <span className="px-1">
                                {!penalty.missed ? ' ✅ ' : ' ❌ '}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}